import { Component } from '@angular/core';
import {TitleComponent} from "../../components/ui/title/title.component";
import {SharedModule} from "../../shared/shared.module";
import {ButtonComponent} from "../../components/ui/button/button.component";
import {CardComponent} from "../../components/ui/card/card.component";
import {InputComponent} from "../../components/ui/input/input.component";
import {Column, TableComponent} from "../../components/ui/table/table.component";
import {TabComponent} from "../../components/ui/tab/tab.component";
import {TabsComponent} from "../../components/ui/tabs/tabs.component";
import {ModalService} from "../../services/modal.service";
import {EditProjectModalComponent} from "../../components/modals/edit-project-modal/edit-project-modal.component";
import {SelectComponent} from "../../components/ui/select/select.component";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {RouterOutlet} from "@angular/router";
import {AdminAccessDirective} from "../../directives/admin-access.directive";

@Component({
  selector: 'app-projects',
  standalone: true,
  imports: [
    TitleComponent,
    SharedModule,
    ButtonComponent,
    CardComponent,
    InputComponent,
    TableComponent,
    TabComponent,
    TabsComponent,
    SelectComponent,
    ReactiveFormsModule,
    RouterOutlet,
    AdminAccessDirective,
  ],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss'
})
export class ProjectsComponent {

  constructor(private modalService: ModalService) {
  }

  createProject() {
    this.modalService.open(EditProjectModalComponent);
  }
}
